<template>
  <b-row class="px-sm-4 px-md-4 px-lg-0 pt-sm-3 mr-2">
    <b-col cols="12" class="mb-4">
      <PageTitle title="Colaborador" />
    </b-col>

    <b-col class="mb-4">
      <b-button
        class="mr-3"
        variant="danger"
        @click="
          $refs.videoManual.toggleOpen({
            url: 'https://www.youtube.com/watch?v=zAsUsTPoKDk&list=PLW_y7yl6WbLvRvXmlcWDT7-Zi0jR-P721&index=35',
            title: 'Colaborador',
          })
        "
      >
        <i class="fas fa-play mr-1"></i>
        Ver video
      </b-button>
      <a
        class="btn btn-success"
        href="https://api.construp.com.br/assets/Vendedor app.pdf"
        target="_blank"
        download
      >
        <i class="fas fa-file-pdf c-white"></i> Baixar Manual
      </a>
    </b-col>

    <b-col cols="12" class="mb-4" v-if="whatClerkPermission()">
      <b-button
        id="show-modal"
        variant="success"
        @click="$refs.modalNewClerk.toggleOpen({ data: table.data })"
      >
        <i class="fas fa-plus mr-2"></i>
        Adicionar colaborador
      </b-button>
    </b-col>

    <b-col cols="12" md="10" class="mb-2">
      <input
        type="text"
        v-model="filterClerk"
        class="form-control"
        placeholder="Nome do colaborador a pesquisar"
        @keyup.enter="dataFilteredSearch()"
      />
    </b-col>

    <b-col cols="12" md="2" class="mb-4">
      <b-button
        variant="success"
        class="btn-block"
        @click="dataFilteredSearch()"
      >
        <i class="fas fa-search mr-2"></i>
        Pesquisar
      </b-button>
    </b-col>

    <b-col cols="12">
      <b-table
        striped
        hover
        show-empty
        empty-text="Sem colaboradores encontrados"
        :fields="table.headers"
        :items="table.data"
        :busy="loading"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>Carregando...</strong>
          </div>
        </template>

        <template #cell(created_at)="data">
          {{ formatDate(data.item.created_at) }}
        </template>

        <template #cell(status)="data">
          {{ data.item.status == 1 ? 'Ativo' : 'Bloqueado' }}
        </template>

        <template #cell(action)="data">
          <b-col class="pr-0" v-if="whatClerkPermission()">
            <b-button
              variant="outline-dark"
              size="sm"
              title="Atualizar dados"
              class="mr-2 mb-2"
              @click="
                $refs.modalUpdateClerk.toggleOpen({
                  id: data.item.id,
                  name: data.item.name,
                  phone: data.item.phone,
                  code: data.item.code,
                  cpf: data.item.cpf,
                  status: data.item.status,
                  email: data.item.email,
                  id_external: data.item.id_external,
                })
              "
            >
              <i class="fas fa-edit"></i>
            </b-button>

            <b-button
              variant="outline-dark"
              size="sm"
              title="Excluir dados"
              class="mr-2 mb-2"
              @click="
                $refs.modalDeleteClerk.toggleOpen({
                  id: data.item.id,
                  name: data.item.name,
                })
              "
            >
              <i class="fas fa-trash"></i>
            </b-button>

            <b-button
              variant="outline-dark"
              size="sm"
              title="Permissões colaborador"
              class="mr-2 mb-2"
              :disabled="data.item.status == 0"
              @click="
                $refs.modalPermissionClerk.toggleOpen({
                  id: data.item.id,
                  nameClerk: data.item.name,
                  permission: data.item.permission,
                })
              "
            >
              <i class="fas fa-key fa-shake"></i>
            </b-button>
          </b-col>
        </template>
      </b-table>
    </b-col>
    <ModalNewClerk ref="modalNewClerk" @clerkNew="getAll()" />
    <ModalUpdateClerk ref="modalUpdateClerk" @clerkUpdate="getAll()" />
    <ModalDeleteClerk ref="modalDeleteClerk" @clerkUpdate="getAll()" />
    <ModalPermissionClerk ref="modalPermissionClerk" @clerkUpdate="getAll()" />
    <VideoManual ref="videoManual" />
  </b-row>
</template>

<script>
import { mapState } from 'vuex';
import UserTypes from '@/enums/UserTypes';
import TypePermission from '@/enums/Clerk/TypePermission';
import NamePermission from '@/enums/Clerk/NamePermission';
import PageTitle from '../../../components/PageTitle.vue';
import makeToast from '../../../mixins/makeToast';
import ModalNewClerk from '../clerk-app/ModalNewClerk.vue';
import ModalUpdateClerk from '../clerk-app/ModalUpdateClerk.vue';
import ModalDeleteClerk from '../clerk-app/ModalDeleteClerk.vue';
import ModalPermissionClerk from '../clerk-app/ModalPermissionClerk.vue';
import VideoManual from '@/components/VideoManual.vue';

export default {
  name: 'ClerkApp',
  mixins: [makeToast],
  components: {
    PageTitle,
    ModalNewClerk,
    ModalUpdateClerk,
    ModalDeleteClerk,
    ModalPermissionClerk,
    VideoManual,
  },
  data() {
    return {
      loading: false,
      showModal: false,
      filterClerk: '',
      dataFiltered: '',
      table: {
        headers: [
          {
            key: 'id',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'created_at',
            label: 'Data',
            sortable: true,
          },
          {
            key: 'name',
            label: 'Colaborador',
            sortable: true,
          },
          // {
          //   key: 'code',
          //   label: 'Cupom',
          //   sortable: false,
          //   headerClass: "d-none d-md-table-cell",
          //   tdClass: "d-none d-md-table-cell" ,
          //   thClass: "d-none d-md-table-cell"
          // },
          {
            key: 'phone',
            label: 'Telefone',
            sortable: false,
            headerClass: 'd-none d-md-table-cell',
            tdClass: 'd-none d-md-table-cell',
            thClass: 'd-none d-md-table-cell',
          },
          {
            key: 'cpf',
            label: 'CPF',
            sortable: false,
            headerClass: 'd-none d-md-table-cell',
            tdClass: 'd-none d-md-table-cell',
            thClass: 'd-none d-md-table-cell',
          },
          {
            key: 'status',
            label: 'Status',
            sortable: false,
          },
          {
            key: 'action',
            label: 'Ações',
            sortable: false,
          },
        ],
        data: [],
      },
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
  },
  mounted() {
    this.getAll();
  },

  methods: {
    dataFilteredSearch() {
      this.table.data = this.dataFiltered.filter((item) => {
        return (
          item.name.toLowerCase().indexOf(this.filterClerk.toLowerCase()) > -1
        );
      });
    },

    getAll() {
      this.loading = true;
      const idUser = this.userTypeId();

      const routeData =
        this.$route.meta.userType == UserTypes.BALCONISTA
          ? this.$store.dispatch('balconista/getDataClerk', idUser)
          : this.$store.dispatch('shopkeeper/getClerk', idUser);

      routeData
        .then((response) => {
          this.table.data = response.data;
          this.dataFiltered = this.table.data;
        })
        .catch(() => {
          this.makeToast('Erro', 'Houve um erro ao trazer os dados', 'danger');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatDate(value) {
      let newData = value.slice(0, -9);
      let split = newData.split('-');
      newData = split[2] + '/' + split[1] + '/' + split[0];
      return newData;
    },
    userTypeId() {
      return this.$route.meta.userType == UserTypes.BALCONISTA
        ? this.dadosUsuario.construp_user_id
        : this.dadosUsuario.id;
    },
    whatClerkPermission() {
      if (this.$route.meta.userType == UserTypes.BALCONISTA) {
        const permissionClerk = JSON.parse(
          localStorage.getItem('permissionClerk')
        );
        const permission = permissionClerk.find(
          (element) => element.name == NamePermission.BALCONISTA
        );

        if (
          this.$route.meta.userType == UserTypes.BALCONISTA &&
          permission.type == TypePermission.BALCONISTA
        ) {
          return false;
        }
      }
      return true;
    },
  },
};
</script>
<style></style>
